import React, { useState } from 'react'
import { css as hcss } from '@emotion/css'
// import { Button } from '~/pagui'
import { injectIntl, InjectedIntlProps } from 'gatsby-plugin-intl'
// import { useMutation } from '@apollo/client'
// import { CREATE_CONTACT_REQUEST } from '~/services/api'
// import { SendContactRequest } from '~/services/api/__generated__/SendContactRequest'
import PagilyBouncing from './PagilyBouncing'
import { Link } from '@reach/router'

type Props = {
  isPagilyAnimation?: boolean
} & InjectedIntlProps
const formBlock = hcss`
    width : 90%; 
    margin : auto; 
    margin-top : 50px;
    background-color : #f5f5eb; 
    padding : 150px 30px;
    border-radius : 10px; 
    position : relative;    
    margin-bottom : 50px;
    display : flex; 
    align-items: center; 
    @media(max-width : 960px){
      padding : 50px 20px 50px 20px; 
   
      }
    
`
const formBlockCenter = hcss`
width : 60%; 
margin : auto;
@media(max-width : 1400px){
width : 70%;
}
@media(max-width : 960px){
width : 100%;  }
`

const formBlockTitle = hcss`
font-size : 40px; 
text-align : center; 
@media(max-width : 1400px){
font-size : 35px; 
  }
  @media(max-width : 960px){
    font-size : 20px; 
    line-height : 20px;
    margin-bottom : 20px; 
    }
`

const formBlockText = hcss`
font-family : 'Matrice-SemiBold'; 
font-size : 25px; 
line-height : 25px;
text-align : center; 
margin : 10px 0 50px 0 ;
@media(max-width : 1400px){
  font-size : 20px; 
    }
    @media(max-width : 960px){
      font-size : 14px;
      line-height : 15px; 
      }
`

// const form = hcss`
// display : flex; 
// justify-content : center; 
// align-items : center; 
// @media(max-width : 1400px){
//  flex-wrap : wrap;

//   }
// `

// const formInput = hcss`
// background-color: white; 
// border: solid 3px #7af0b6;
// padding: 15px;
// border-radius: 35px;
// width: 60%; 
// font-family: 'Montserrat-Regular';
// @media(max-width : 1400px){
//   width : 80%
//   }
//   @media(max-width : 960px){
//   width : 100%;
//     }

// `

// const btnBlock = hcss`
// margin-left : 30px; 
// @media(max-width : 1400px){
//   margin-top : 50px; 
//   }
//   @media(max-width : 960px){
//    margin-top : 20px; 
//    margin-left : 0; 
//     }

// `
// const messageSentText = hcss`

// color :  #7af0b6;
// font-family : 'Montserrat-Regular'; 
// font-weight : bold; 
// text-align : center; 
// font-size : 25px; 
// @media(max-width : 960px){
//   font-size : 20px; 
//   }

// `
// const errorMessage = hcss`
//   color : red; 
//   font-family : 'Montserrat-Regular'; 
//   margin-left : 65px; 
//   margin-top : 20px;
// `


const btn = hcss`
text-align : center;
color: white; 
display : block ; 
margin : auto ; 
background-color : #53d69a; 
border-radius  : 50px;
width : 200px;
padding : 10px 0;  
font-family : 'Montserrat-Bold'; 
transition : 0.2s;
&:hover{
  color : #53d69a; 
  background-color : white; 
}
&:active {
  transform: scale(0.9);
}

`


const BetaSubscription: React.FC<Props> = ({ isPagilyAnimation }) => {
  // const handleSent = (res: SendContactRequest) => {
  //   if (res.sendContactRequest === true) {
  //     setEmail('')
  //     setMessageSent(true)
  //   } else {
  //     alert("Oups votre message n'a pas été envoyé")
  //   }
  // }

  // const [sendRequest] = useMutation<SendContactRequest>(
  //   CREATE_CONTACT_REQUEST,
  //   { onCompleted: handleSent }
  // )

  // const [email, setEmail] = useState('')
  // const emailValidator = /^[A-Za-z0-9-_.]{1,}@[a-z]{1,}\.[a-z]{2,}$/
  // const [errorEmail, setErrorEmail] = useState('')
  // const [messageSent, setMessageSent] = useState(false)

  // const checkEmail = () => {
  //   const isValid = emailValidator.test(email)
  //   return !isValid
  // }
  // const submit = () => {
  //   let validFunction = true

  //   if (checkEmail()) {
  //     validFunction = false
  //     setErrorEmail('Veuillez entrer un email valide')
  //   } else {
  //     setErrorEmail('')
  //   }

  //   if (validFunction == true) {
  //     sendRequest({
  //       variables: {
  //         input: {
  //           name: ``,
  //           email: email,
  //           company: '',
  //           isBeta: true,
  //           isOptIn: false,
  //           question: '',
  //         },
  //       },
  //     })
  //   }
  // }

  return (
    <>
      <section className={formBlock} id="beta_subscription">
        {isPagilyAnimation ? <></> : <PagilyBouncing />}
        <div className={formBlockCenter}>
          <h2 className={formBlockTitle}> Testez gratuitement</h2>
          <p className={formBlockText}>
            Pagily est en bêta-test.
            <br />
            Inscrivez-vous pour recevoir votre invitation.
          </p>
          <a href='mailto:contact@pagily.io' className={btn}>Contactez-nous</a>

{/* 
          {!messageSent ? (
            <>
              <form className={form}>
                <label htmlFor="email" />
                <input
                  className={formInput}
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Saisissez votre adresse mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                ></input>
                <div className={btnBlock}>
                  <Button
                    style={{ padding: 5 }}
                    title="Recevoir mon invit’"
                    onPress={submit}
                  />
                </div>
              </form>
              <p className={errorMessage}>{errorEmail}</p>
            </>
          ) : (
            <p className={messageSentText}>
              Votre inscription est bien prise en compte.
              <br />
              Vous allez recevoir un email avec toutes les informations.
              <br />
              Merci !
            </p>
          )} */}
        </div>
      </section>
    </>
  )
}

export default injectIntl(BetaSubscription)
